<div class="loader"></div>
<div class="play-controls">
  <button *ngIf="!isLoading && !isPlaying" mat-icon-button class="control-btn play-btn" (click)="play($event)">
    <mat-icon>play_arrow</mat-icon>
  </button>
  <button *ngIf="canPlay && isPlaying" mat-icon-button class="control-btn pause-btn" (click)="pause($event)">
    <mat-icon>pause</mat-icon>
  </button>
  <div class="loader-place" *ngIf="isLoading">
    <mat-spinner class="loading-spinner"></mat-spinner>
  </div>
</div>
<div class="controls">
  <div class="current-time">{{currentTime}}</div>
  <div class="total-time">{{totalTime}}</div>
  <mat-slider
    [disabled]="!canPlay"
    class="progress-bar"
    [min]="0"
    [max]="100"
    [value]="playingProgress"
    (input)="changeProgress($event)"
  ></mat-slider>
</div>
<a mat-icon-button class="download-btn" href="{{src}}" target="_blank">
  <mat-icon>file_download</mat-icon>
</a>

<audio #player class="player" controls="controls" preload="data">
  <source *ngIf="audio" [src]="audio" type="audio/x-wav">
</audio>
